import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ConfirmProvider } from '../components/ui/Confirm';
import { ToastProvider } from '../components/ui/Toast';
import { AUTH_QUERY_KEY } from '../hooks/useAuth';
import { setUnauthorizedHandler } from '../lib/api';
import { createQueryClient } from './queryClient';
import { createAppRouter } from './router';

const queryClient = createQueryClient();
const router = createAppRouter();

// Session expired mid-use: forget the cached user and send them to sign in, then back where they were.
setUnauthorizedHandler((nextPath) => {
  queryClient.setQueryData(AUTH_QUERY_KEY, null);
  void router.navigate(`/login?next=${encodeURIComponent(nextPath)}`, { replace: true });
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ConfirmProvider>
          <RouterProvider router={router} />
        </ConfirmProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
